module.exports = __webpack_public_path__ + "img/Icon - Success@2x.eb822bff.png";